/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addButton: "Add",
    checkboxFalseStringValue: "No",
    checkboxTrueStringValue: "Yes",
    confirmDelete: "Confirm delete ?",
    deleteButton: "Delete",
    editButton: "Edit",
    emptyState: {
        clearFilter: {
            label: "Reset filters"
        }
    },
    footerInfo: {
        displayableRowsCount: {
            noFilter: {
                plural: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":16}}}) : helper)))
    + " rows";
},"useData":true}),
                singular: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":16}}}) : helper)))
    + " row";
},"useData":true})
            },
            withFilter: {
                plural: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrDisplayableRows") || (depth0 != null ? lookupProperty(depth0,"nbrDisplayableRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrDisplayableRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":22}}}) : helper)))
    + " of "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":42}}}) : helper)))
    + " rows";
},"useData":true}),
                singular: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrDisplayableRows") || (depth0 != null ? lookupProperty(depth0,"nbrDisplayableRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrDisplayableRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":22}}}) : helper)))
    + " of "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrTotalRows") || (depth0 != null ? lookupProperty(depth0,"nbrTotalRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrTotalRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":42}}}) : helper)))
    + " row";
},"useData":true})
            }
        },
        selectedRowsCount: {
            plural: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrSelectedRows") || (depth0 != null ? lookupProperty(depth0,"nbrSelectedRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrSelectedRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":19}}}) : helper)))
    + " selected rows";
},"useData":true}),
            singular: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"nbrSelectedRows") || (depth0 != null ? lookupProperty(depth0,"nbrSelectedRows") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nbrSelectedRows","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":19}}}) : helper)))
    + " selected row";
},"useData":true})
        }
    },
    hierarchy: {
        collapse: {
            all: "Collapse all rows"
        },
        expand: {
            all: "Expand all rows"
        },
        selectChildren: {
            selectAll: "select all",
            shortSelectAll: "all",
            shortUnselectAll: "none",
            unselectAll: "unselect all"
        }
    },
    impossibleToMultiSelect: "Impossible to edit multiple lines",
    multipleLineSelected: "Multiple lines selected",
    multiselect: {
        selectAll: "Select all",
        unselectAll: "Unselect all"
    },
    noDataToDisplay: "<< No data >>",
    noLineSelected: "No line selected",
    paginator: {
        label: {
            entries: "entries",
            of: "of",
            pages: "Pages",
            to: "to"
        },
        select: {
            all: "All"
        }
    },
    searchInputLabel: "Filter",
    searchInputLabelJSRegex: "(regex)",
    searchLabel: "Search",
    selectLineToDelete: "Select at least one line to delete",
    selectLineToEdit: "Select at least one line to edit"
};